module.exports = __webpack_public_path__ + "img/kehu_shiliuwuye.45828f15.png";